import React from "react";
import { Col, Row } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import AddRateHook from "../../hook/review/add-rate-hook";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import DisableButton from "../Uitily/DisableButton";

const RatePost = () => {
  const { id } = useParams();
  const [
    OnChangeRateText,
    OnChangeRateValue,
    rateText,
    rateValue,
    user,
    onSubmit,
    checkISComplate,
  ] = AddRateHook(id);

  var name = "";
  if (user) name = user.name;

  const setting = {
    size: 20,
    count: 5,
    color: "#979797",
    activeColor: "#ffc107",
    value: 7.5,
    a11y: true,
    isHalf: true,
    emptyIcon: <i className="far fa-star" />,
    halfIcon: <i className="fa fa-star-half-alt" />,
    filledIcon: <i className="fa fa-star" />,
    onChange: (newValue) => {
      OnChangeRateValue(newValue);
    },
  };
  return (
    <div>
      <Row className="mt-3 ">
        <Col sm="6" className="d-flex flex-sm-column">
          <div className="rate-name  d-inline  mt-1 ">{name}</div>
          <ReactStars {...setting} />
        </Col>
      </Row>
      {/* <Row>{!isRateEmpty ? <h2>من فضلك قيم المنتج </h2> : null}</Row> */}
      <Row className="border-bottom mx-2">
        <Col className="d-felx me-4 pb-2">
          <textarea
            value={rateText}
            onChange={OnChangeRateText}
            className="input-form-area p-2 mt-3"
            rows="2"
            cols="20"
            placeholder="اكتب تعليقك...."
          />
          <div className=" d-flex justify-content-end al">
            {checkISComplate ? (
              <button
                onClick={onSubmit}
                className="product-cart-add px-3  py-2 text-center d-inline"
              >
                اضف تعليق
              </button>
            ) : (
              <DisableButton title="اضف تعليق" />
            )}
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </div>
  );
};

export default RatePost;
